import React from 'react';

function Section4() {
  return (
    <section
      style={{
        background: 'linear-gradient(to right, #000000, #0f2027)', // Black gradient
        color: '#ffffff',
        padding: '80px 20px',
        textAlign: 'center',
        borderRadius: '12px',
        margin: '40px 20px',
        boxShadow: '0 10px 40px rgba(0,0,0,0.6)',
      }}
    >
      <h2
        style={{
          fontSize: '3rem',
          fontWeight: '700',
          color: '#00BFFF', // Vibrant Blue
          marginBottom: '20px',
          letterSpacing: '1px',
        }}
      >
        Essential Shield Protection
      </h2>

      <p
        style={{
          fontSize: '1.2rem',
          color: '#e0e0e0',
          maxWidth: '700px',
          margin: '0 auto 40px',
          lineHeight: '1.8',
        }}
      >
        Experience ultimate protection for your vehicle with our Essential Shield package —
        designed to maintain shine, block UV rays, and guard your car’s finish against daily
        wear and tear.
      </p>

      <button
        style={{
          backgroundColor: '#00BFFF',
          color: '#000',
          padding: '14px 40px',
          fontSize: '1.1rem',
          border: 'none',
          borderRadius: '50px',
          cursor: 'pointer',
          boxShadow: '0 0 20px #00BFFF88',
          transition: 'all 0.3s ease',
        }}
        onMouseOver={(e) => {
          e.target.style.backgroundColor = '#007ACC';
          e.target.style.boxShadow = '0 0 25px #007ACCaa';
        }}
        onMouseOut={(e) => {
          e.target.style.backgroundColor = '#00BFFF';
          e.target.style.boxShadow = '0 0 20px #00BFFF88';
        }}
      >
        Book Your Shield
      </button>
    </section>
  );
}

export default Section4;
